import { render, staticRenderFns } from "./FilterNeedHelp.vue?vue&type=template&id=1b4ab04c&scoped=true&"
import script from "./FilterNeedHelp.vue?vue&type=script&lang=js&"
export * from "./FilterNeedHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4ab04c",
  null
  
)

export default component.exports